import {api} from '../components/Base/App';

export default {
    enable(exportName, objectId) {
        return api({
            method: 'post',
            url: `/rest/channelmanager/${exportName}/enable`,
            data: {
                objectIds: [objectId]
            }

        });
    },
    disable(exportName, objectId) {
        return api({
            method: 'post',
            url: `/rest/channelmanager/${exportName}/disable`,
            data: {
                objectIds: [objectId]
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/Exports.js